document.addEventListener('livewire:navigated', function ()  {
    initializeMenu();

    function initializeMenu() {
        var menuButton = $('#menuButton');
        if (menuButton.length) {
            menuButton.on('click', function(e) {
                e.preventDefault();
                menuButton.toggleClass('is-active');
                $('body').toggleClass('menu-active');
            });
        }
    }
});
